import { render, staticRenderFns } from "./EventInstoTapApp.vue?vue&type=template&id=37d2f41d&scoped=true&"
import script from "./EventInstoTapApp.vue?vue&type=script&lang=js&"
export * from "./EventInstoTapApp.vue?vue&type=script&lang=js&"
import style0 from "./EventInstoTapApp.vue?vue&type=style&index=0&id=37d2f41d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2f41d",
  null
  
)

export default component.exports